import { render } from "./Jurnal.vue?vue&type=template&id=2bca5b2a"
import script from "./Jurnal.vue?vue&type=script&lang=js"
export * from "./Jurnal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__